"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable react/no-array-index-key */


var component_icon_font_1 = __importDefault(require("@rotaryintl/component-icon-font"));

var component_wbr_string_1 = __importDefault(require("@rotaryintl/component-wbr-string"));

var hook_use_bem_classes_1 = __importDefault(require("@rotaryintl/hook-use-bem-classes"));

var classnames_1 = __importDefault(require("classnames"));

var link_component_1 = require("../link/link.component");

var HeaderMegaNav = function (props) {
  var _a;

  var _b, _c;

  var bem = (0, hook_use_bem_classes_1.default)('rwc-header-mega-nav');

  var handleLinkClick = function () {
    props.close();
    props.setIsMobileMenuOpen(false);
  };

  return (0, jsx_runtime_1.jsx)("div", __assign({
    role: "menu",
    id: "".concat(props.mainNavTitle, "-menu"),
    "aria-label": "".concat(props.mainNavTitle, "-nav-button"),
    className: (0, classnames_1.default)(bem(), (_a = {}, _a[bem('', 'open')] = props.isOpen, _a[bem('', 'transition')] = props.fadeOpen, _a))
  }, {
    children: (0, jsx_runtime_1.jsxs)("div", __assign({
      className: (0, classnames_1.default)(bem('container'), 'rwc-scrollbar-grey')
    }, {
      children: [(0, jsx_runtime_1.jsxs)("button", __assign({
        role: "menuitem",
        className: bem('back-button'),
        onClick: props.close
      }, {
        children: [(0, jsx_runtime_1.jsx)(component_icon_font_1.default, {
          type: "fas-angle-right",
          size: "16"
        }), (0, jsx_runtime_1.jsx)(component_wbr_string_1.default, __assign({
          tag: "span"
        }, {
          children: props.backButtonText
        }))]
      })), props.bottomLink !== undefined ? (0, jsx_runtime_1.jsx)("h5", __assign({
        className: bem('title')
      }, {
        children: (0, jsx_runtime_1.jsx)(link_component_1.Link, __assign({}, props.bottomLink, {
          linkText: props.mainNavTitle,
          onClick: handleLinkClick,
          shouldAllowDefault: true
        }))
      })) : (0, jsx_runtime_1.jsx)(component_wbr_string_1.default, __assign({
        tag: "h5",
        className: bem('title')
      }, {
        children: props.mainNavTitle
      })), (0, jsx_runtime_1.jsxs)("div", __assign({
        className: bem('top')
      }, {
        children: [(0, jsx_runtime_1.jsx)("div", __assign({
          className: bem('link-cols')
        }, {
          children: (_b = props === null || props === void 0 ? void 0 : props.columns) === null || _b === void 0 ? void 0 : _b.map(function (column, colIdx) {
            var _a;

            if (column.type === 'col1') {
              return (0, jsx_runtime_1.jsx)("div", {
                children: (_a = column.linkGroups) === null || _a === void 0 ? void 0 : _a.map(function (lg, lgIdx) {
                  var _a;

                  var _b, _c, _d;

                  return (0, jsx_runtime_1.jsxs)("section", {
                    children: [lg.headerLink && lg.headerLink.linkText && lg.headerLink.linkUrl && (0, jsx_runtime_1.jsx)("div", __assign({
                      className: (0, classnames_1.default)(bem('link-header'), (_a = {}, _a[bem('link-header', 'mt')] = lgIdx > 0 && ((_c = (_b = lg.subLinks) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0) > 0, _a))
                    }, {
                      children: (0, jsx_runtime_1.jsx)(link_component_1.Link, __assign({
                        role: "menuitem",
                        onClick: handleLinkClick,
                        shouldAllowDefault: true,
                        className: bem('link')
                      }, lg.headerLink))
                    })), lg.subLinks && lg.subLinks.length > 0 && (0, jsx_runtime_1.jsxs)("ul", __assign({
                      className: bem('link-list')
                    }, {
                      children: [(_d = lg.subLinks) === null || _d === void 0 ? void 0 : _d.map(function (sublink, lnkIdx) {
                        return sublink && sublink.linkText && sublink.linkUrl && (0, jsx_runtime_1.jsx)("li", {
                          children: (0, jsx_runtime_1.jsx)(link_component_1.Link, __assign({
                            role: "menuitem",
                            onClick: handleLinkClick,
                            shouldAllowDefault: true,
                            className: bem('link')
                          }, sublink))
                        }, "col1-lnk-".concat(colIdx, "-").concat(lnkIdx));
                      }), lg.viewAllLink && lg.viewAllLink.linkText && lg.viewAllLink.linkUrl && (0, jsx_runtime_1.jsx)("li", {
                        children: (0, jsx_runtime_1.jsx)(link_component_1.Link, __assign({
                          role: "menuitem",
                          onClick: handleLinkClick,
                          shouldAllowDefault: true,
                          className: (0, classnames_1.default)(bem('link'), bem('link', 'bold'))
                        }, lg.viewAllLink))
                      }, "col1-lnk-".concat(colIdx, "-view-all"))]
                    }))]
                  }, "".concat(bem('col-lg'), "-").concat(colIdx, "-").concat(lgIdx));
                })
              }, column.type + colIdx);
            }

            if (column.type === 'col2') {
              return (0, jsx_runtime_1.jsx)("div", __assign({
                className: bem('double')
              }, {
                children: column.linkGroups.map(function (doubleCol, doubleColIdx) {
                  return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, {
                    children: [doubleCol.headerLink && doubleCol.headerLink.linkText && doubleCol.headerLink.linkUrl && (0, jsx_runtime_1.jsx)("div", __assign({
                      className: bem('link-header')
                    }, {
                      children: (0, jsx_runtime_1.jsx)(link_component_1.Link, __assign({
                        role: "menuitem",
                        onClick: handleLinkClick,
                        shouldAllowDefault: true,
                        className: bem('link')
                      }, doubleCol.headerLink))
                    })), (0, jsx_runtime_1.jsx)("div", __assign({
                      className: bem('double-section')
                    }, {
                      children: (0, jsx_runtime_1.jsxs)("div", __assign({
                        className: bem('double-col')
                      }, {
                        children: [doubleCol.col1 && doubleCol.col1.length > 0 && (0, jsx_runtime_1.jsx)("ul", __assign({
                          className: (0, classnames_1.default)(bem('double-col', '1'), bem('link-list'))
                        }, {
                          children: doubleCol.col1.map(function (link, lnkIdx) {
                            return link && link.linkText && link.linkUrl && (0, jsx_runtime_1.jsx)("li", {
                              children: (0, jsx_runtime_1.jsx)(link_component_1.Link, __assign({
                                role: "menuitem",
                                onClick: handleLinkClick,
                                shouldAllowDefault: true,
                                className: bem('link')
                              }, link))
                            }, "col2-1-lnk-".concat(colIdx, "-").concat(lnkIdx));
                          })
                        })), doubleCol.col2 && doubleCol.col2.length > 0 && (0, jsx_runtime_1.jsxs)("ul", __assign({
                          className: (0, classnames_1.default)(bem('double-col', '2'), bem('link-list'))
                        }, {
                          children: [doubleCol.col2.map(function (link, lnkIdx) {
                            return link && link.linkText && link.linkUrl && (0, jsx_runtime_1.jsx)("li", {
                              children: (0, jsx_runtime_1.jsx)(link_component_1.Link, __assign({
                                role: "menuitem",
                                onClick: handleLinkClick,
                                shouldAllowDefault: true,
                                className: bem('link')
                              }, link))
                            }, "col2-1-lnk-".concat(colIdx, "-").concat(lnkIdx));
                          }), doubleCol.viewAllLink && doubleCol.viewAllLink.linkText && doubleCol.viewAllLink.linkUrl && (0, jsx_runtime_1.jsx)("li", {
                            children: (0, jsx_runtime_1.jsx)(link_component_1.Link, __assign({
                              role: "menuitem",
                              onClick: handleLinkClick,
                              shouldAllowDefault: true
                            }, doubleCol.viewAllLink, {
                              className: (0, classnames_1.default)(bem('link'), bem('link', 'bold'))
                            }))
                          })]
                        }))]
                      }))
                    }), "".concat(bem(), "--").concat(colIdx, "-").concat(doubleColIdx))]
                  });
                })
              }), column.type + colIdx);
            }

            return null;
          })
        })), props.featuredImage && props.featuredLink && props.featuredLink.linkText && props.featuredLink.linkUrl && props.featuredDescription && (0, jsx_runtime_1.jsxs)("div", __assign({
          className: bem('featured-callout')
        }, {
          children: [props.featuredImage, (0, jsx_runtime_1.jsx)(link_component_1.Link, __assign({
            role: "menuitem",
            onClick: handleLinkClick,
            shouldAllowDefault: true,
            className: bem('featured-callout-link')
          }, props.featuredLink)), (0, jsx_runtime_1.jsx)(component_wbr_string_1.default, __assign({
            tag: "div",
            className: bem('featured-callout-desc')
          }, {
            children: props.featuredDescription
          }))]
        }))]
      })), props.bottomLink && props.bottomLink.linkText && props.bottomLink.linkUrl && (0, jsx_runtime_1.jsx)("div", __assign({
        className: bem('bottom')
      }, {
        children: (0, jsx_runtime_1.jsxs)("a", __assign({
          role: "menuitem",
          className: bem('bottom-link'),
          href: props.bottomLink.linkUrl
        }, {
          children: [(0, jsx_runtime_1.jsx)(component_wbr_string_1.default, __assign({
            tag: "span"
          }, {
            children: (_c = props.bottomLink) === null || _c === void 0 ? void 0 : _c.linkText
          })), (0, jsx_runtime_1.jsx)(component_icon_font_1.default, {
            type: "fas-angle-right",
            size: "16",
            color: "##0067C8"
          })]
        }))
      }))]
    }))
  }));
};

exports.default = HeaderMegaNav;